require.register("app/ui/modal/Confirm", function(exports, require, module){
  $0
  
});

